<script setup>
import { defineProps } from 'vue';
import { useCustomerStore } from '@/stores/customer';
import { useCurrenciesStore } from '@/stores/currencies';

defineProps({
	rewards: {
		type: Array,
		required: true,
		default: () => [],
	}
});

const customerStore = useCustomerStore();
const currenciesStore = useCurrenciesStore();

const formatCurrency = (amount) => {
	const _amount = parseFloat(amount);
	if (customerStore.customer && customerStore.customer.currency) {
		return currenciesStore.format_currency(_amount, customerStore.customer.currency.code);
	}
	return currenciesStore.format_currency(_amount);
};
</script>

<template>
	<div class="success-rewards-card">
		<div class="rewards-header">
			<div class="reward-icon-container">
				<svg class="check-circle" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
					<circle cx="12" cy="12" r="10" stroke-width="2" />
					<path stroke-linecap="round" stroke-linejoin="round" d="M8 12l3 3 5-6" />
				</svg>
			</div>
			<span class="rewards-card-badge">{{ $t('general.rewards_granted') || 'REWARDS GRANTED' }}</span>
		</div>
		
		<div class="rewards-list">
			<div v-for="reward in rewards" :key="reward.id" class="reward-list-item">
				<span class="reward-bullet">•</span>
				<div class="reward-name-qty">
					<span class="reward-name">
						{{ $t('general.' + reward.type.toLowerCase()) }} {{ reward.name }}
					</span>
					<span v-if="reward.type.toLowerCase() === 'freespin' && reward.quantity" class="reward-qty-badge">{{ reward.quantity }}</span>
					<span v-else-if="reward.type.toLowerCase() === 'freebet' && reward.amount" class="reward-qty-badge">{{ formatCurrency(reward.amount) }}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.success-rewards-card {
	background: color-mix(in srgb, var(--white) 3%, transparent);
	border-radius: 8px;
	padding: 15px 20px;
	width: 100%;
	min-width: 100%;
	max-width: 100%;
	box-sizing: border-box;
	margin: 0 auto;
	align-self: stretch;
}
.rewards-header {
	display: flex;
	align-items: center;
	gap: 10px;
	margin-bottom: 12px;
}
.reward-icon-container {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 44px;
	height: 44px;
	border-radius: 50%;
	background: color-mix(in srgb, var(--primary) 10%, transparent);
	border: 1px solid color-mix(in srgb, var(--primary) 20%, transparent);
	flex-shrink: 0;
}
.check-circle {
	width: 24px;
	height: 24px;
	stroke: var(--primary);
}
.rewards-card-badge {
	font-size: 0.85rem;
	text-transform: uppercase;
	font-weight: 700;
	letter-spacing: 0.05em;
	color: #6c829d;
}
.rewards-list {
	display: flex;
	flex-direction: column;
	gap: 10px;
	padding-left: 16px;
}
.reward-list-item {
	display: flex;
	align-items: center;
	gap: 8px;
}
.reward-bullet {
	color: var(--primary);
	font-size: 1.2rem;
	line-height: 1;
}
.reward-name-qty {
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: wrap;
}
.reward-name {
	font-size: 1rem;
	font-weight: 700;
	color: var(--white);
}
.reward-qty-badge {
	background: color-mix(in srgb, var(--white) 10%, transparent);
	padding: 2px 8px;
	border-radius: 6px;
	font-size: 0.85rem;
	font-weight: 600;
	color: var(--white);
}
</style>
